// extracted by mini-css-extract-plugin
export default {"new-course":"NewCourse_new-course__Lzsez","content":"NewCourse_content__Dw0iD","actions":"NewCourse_actions__au4Sy"};